/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M109.337 921.6V614.4a401.408 401.408 0 11802.304 0v307.2h51.2V1024H59.161V921.6zm102.4-307.2h102.4a204.8 204.8 0 01200.704-204.8V307.2a304.128 304.128 0 00-305.152 307.2zM462.617 0h102.4v153.6h-102.4zm440.32 143.872l70.656 72.192-105.984 108.544-71.168-72.192zM49.945 216.064l70.656-72.192 106.496 108.544-71.168 72.192z"/>'
  }
})
